import {TEmailTemplateComponentType, TComponentPayload} from "../../interfaces/email";

export interface DefaultEmailTemplate {
  id: string;
  name: string;
  subject: string;
  mailSender?: string;
  components: TComponentPayload[];
  icon: string;
  thumbnail?: string;
}

export const defaultEmailTemplates: DefaultEmailTemplate[] = [
  {
    id: 'lancement',
    name: 'Lancement',
    subject: 'Email de lancement',
    mailSender: 'Joozy',
    icon: 'PlayCircleFilledWhiteIcon',
    thumbnail: 'templateemail/vignette01.png',
    components: [
      {order: 0, type: TEmailTemplateComponentType.HEADER, contenu: JSON.stringify({logoUrl: '', backgroundColor: '', gradientEndColor: ''}), label: null, url: null, alt: null, img: null, urlType: null},
      {order: 1, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/cadeau.png', urlType: null},
      {
        order: 2, type: TEmailTemplateComponentType.TEXT, label: null, url: null, alt: null, img: null, urlType: null,
        contenu: `<div style="padding: 20px 0; line-height: 1;"><p style="text-align: justify;"><span style="color: rgb(127, 59, 236); font-size: 40px;font-weight: 700;"><strong>BIENVENUE</strong></span></p><p style="text-align: justify;"><strong><span style="font-size: 20px;font-weight: 900;">sur le site {{operationName}}</span></strong></p><p style="text-align: justify;"><span style="font-size: 12pt; color: rgb(149, 165, 166);">de {{companyName}}</span></p></div>`,
      },
      {
        order: 3, type: TEmailTemplateComponentType.TEXT, label: null, url: null, alt: null, img: null, urlType: null,
        contenu: `<div><p style="text-align: justify;">Votre plateforme cadeaux est d&eacute;sormais ouverte.<br>D&eacute;couvrez une s&eacute;lection de grandes marques et de produits soigneusement choisis pour vous faire plaisir. Parcourez le catalogue, choisissez votre cadeau pr&eacute;f&eacute;r&eacute; et faites-vous livrer directement &agrave; l'adresse de votre choix.</p></div>`,
      },
      {order: 4, type: TEmailTemplateComponentType.BUTTON, contenu: '{"align":"left","rounded":true,"padding":"0 30px"}', label: 'Accéder à mon compte', url: null, alt: null, img: null, urlType: 'shop'},
      {order: 5, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/visuel-mail-cadeaux_02.jpg', urlType: null},
      {order: 6, type: TEmailTemplateComponentType.FOOTER, contenu: null, label: null, url: null, alt: null, img: null, urlType: null},
    ],
  },
  {
    id: 'credit-de-points',
    name: 'Crédit de points',
    subject: 'Email de crédit de points',
    mailSender: 'Joozy',
    icon: 'CelebrationIcon',
    thumbnail: 'templateemail/vignette02.png',
    components: [
      {order: 0, type: TEmailTemplateComponentType.HEADER, contenu: JSON.stringify({logoUrl: '', backgroundColor: '', gradientEndColor: ''}), label: null, url: null, alt: null, img: null, urlType: null},
      {order: 1, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/points.png', urlType: null},
      {
        order: 2, type: TEmailTemplateComponentType.TEXT, label: null, url: null, alt: null, img: null, urlType: null,
        contenu: `<div style="padding: 20px 0; line-height: 1;"><p style="text-align: justify;"><span style="color: rgb(127, 59, 236); font-size: 40px;font-weight: 700;"><strong>{{user.points}}</strong></span></p><p style="text-align: justify;"><strong><span style="font-size: 20px;font-weight: 900;">points cadeaux cr&eacute;dit&eacute;s</span></strong></p><p style="text-align: justify;"><span style="font-size: 12pt; color: rgb(149, 165, 166);">de {{companyName}}</span></p></div>`,
      },
      {
        order: 3, type: TEmailTemplateComponentType.TEXT, label: null, url: null, alt: null, img: null, urlType: null,
        contenu: `<div><p style="text-align: justify;">Bonjour {{user.firstName}}, Profitez de cette occasion pour vous faire plaisir ou pour g&acirc;ter vos proches ?</p></div>`,
      },
      {order: 4, type: TEmailTemplateComponentType.BUTTON, contenu: '{"align":"left","rounded":true,"padding":"0 30px"}', label: 'Accéder à mon compte', url: null, alt: null, img: null, urlType: 'shop'},
      {order: 5, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/visuel-mail-cadeaux_01.jpg', urlType: null},
      {order: 6, type: TEmailTemplateComponentType.FOOTER, contenu: null, label: null, url: null, alt: null, img: null, urlType: null},
    ],
  },
  {
    id: 'erratum',
    name: 'Erratum',
    subject: `Oops ! Un de nos emails s'est perdu`,
    mailSender: 'Joozy',
    icon: 'DoDisturbIcon',
    thumbnail: 'templateemail/vignette03.png',
    components: [
      {order: 0, type: TEmailTemplateComponentType.HEADER, contenu: JSON.stringify({logoUrl: '', backgroundColor: '', gradientEndColor: ''}), label: null, url: null, alt: null, img: null, urlType: null},
      {order: 1, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/erreur.png', urlType: null},
      {
        order: 3, type: TEmailTemplateComponentType.TEXT, label: null, url: null, alt: null, img: null, urlType: null,
        contenu: `<div><p style="text-align: justify;">Il semblerait qu'un email se soit tromp&eacute; de chemin le dimanche {6 mars}. Vous l'avez peut-&ecirc;tre re&ccedil;u par erreur. Toutes nos excuses, le probl&egrave;me a &eacute;t&eacute; r&eacute;solu.</p>\n<p style="text-align: justify;">L'equipe de <strong>{{companyName}}</strong></p></div>`,
      },
      {order: 4, type: TEmailTemplateComponentType.BUTTON, contenu: '{"align":"left","rounded":true,"padding":"0 30px"}', label: 'Accéder à mon compte', url: null, alt: null, img: null, urlType: 'shop'},
      {order: 5, type: TEmailTemplateComponentType.BANNER, contenu: '{"margin":"0"}', label: null, url: null, alt: null, img: 'templateemail/visuel-mail-cadeaux_01.jpg', urlType: null},
      {order: 6, type: TEmailTemplateComponentType.FOOTER, contenu: null, label: null, url: null, alt: null, img: null, urlType: null},
    ],
  },
];